import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { Flyout } from '@els/els-react--flyout';
import InnerHTML from '@Components/InnerHTML';
import { allowedTagsDefault } from '@Services/HtmlSanitizeService';

function ExportInfoTooltip({ ariaLabel, tooltipText }) {
  if (!tooltipText) {
    return null;
  }

  return (
    <Flyout
      trigger="click"
      placement="bottom-end"
      theme="default"
      pointer
      pointerType="primary"
      flyout={
        <div className="tooltip-content">
          <InnerHTML
            html={tooltipText}
            tag="span"
            mode="escape"
            allowedTags={allowedTagsDefault.concat('a')}
            allowedAttributes={['href', 'target']}
          />
        </div>
      }>
      <ButtonWithIcon
        data-e2e="export-info-tooltip"
        type="link"
        linkIconSize="s"
        sprite="InformationOutlineCircle"
        iconOnly
        className="u-els-margin-left-1o2"
        aria-label={ariaLabel}>
        {ariaLabel}
      </ButtonWithIcon>
    </Flyout>
  );
}

ExportInfoTooltip.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
};

export default ExportInfoTooltip;
